import combine from '@eversports/core-io/combine'
import * as s from '@eversports/core-io/sanitizer'
import * as v from '@eversports/core-io/validator'
import { assertNever } from '@eversports/utility-types'

import { RequiredInformationType } from '../../../typings/AdditionalInformation'

import { FieldNameId, Sanitize, Validator } from './types'

/**
 * Generate needed validators for Additional Information
 */
function getValidation(additionalInformation: Array<RequiredInformationType>, countryCode: string) {
  const sanitizer: Sanitize = {}
  const validator: Validator = {}
  const fieldNameIds: FieldNameId = {}

  for (const addInfo of additionalInformation) {
    switch (addInfo) {
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_ADDRESS:
        sanitizer.street = s.string()
        validator.street = v.required()
        fieldNameIds.street = 'field-street'

        sanitizer.detail = s.string()
        validator.detail = v.required()
        fieldNameIds.detail = 'field-detail'

        sanitizer.city = s.string()
        validator.city = v.required()
        fieldNameIds.city = 'field-city'

        sanitizer.country = s.string()
        validator.country = v.required()
        fieldNameIds.country = 'field-country'

        sanitizer.zip = s.string()
        validator.zip = v.required()
        fieldNameIds.zip = 'field-postcode'
        break
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_BIRTHDAY:
        sanitizer.birthday = s.string()
        validator.birthday = v.required()
        fieldNameIds.birthday = 'field-date-birthday'
        break
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_PHONE_NUMBER:
        sanitizer.phoneNumber = s.string()
        validator.phoneNumber = v.telephone()
        fieldNameIds.phoneNumber = 'field-phone-number'
        break
      case RequiredInformationType.REQUIRED_INFORMATION_TYPE_FISCAL_CODE:
        sanitizer.fiscalCode = s.string()
        validator.fiscalCode = v.fiscalCode({ countryCode })
        fieldNameIds.fiscalCode = 'field-fiscal-code'
        break
      default:
        assertNever(addInfo)
    }
  }

  return combine({
    sanitizer: s.sanitizer(sanitizer),
    validator: v.validator(validator),
    fieldNameIds,
  })
}

export default getValidation
